import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface ImportConfigProps {
  manualEntryEnabled: boolean;
  bulkImportEnabled: boolean;
  onManualEntryChange: (enabled: boolean) => void;
  onBulkImportChange: (enabled: boolean) => void;
}

export function ImportConfig({
  manualEntryEnabled,
  bulkImportEnabled,
  onManualEntryChange,
  onBulkImportChange,
}: ImportConfigProps) {
  return (
    <div className="space-y-4">
      <Label>Configurações de Importação</Label>
      
      <div className="flex items-center justify-between p-3 border rounded-lg">
        <div>
          <Label htmlFor="manual-entry" className="text-sm">
            Lançamento Manual
          </Label>
          <p className="text-xs text-muted-foreground">
            Permitir adicionar transações manualmente
          </p>
        </div>
        <Switch
          id="manual-entry"
          checked={manualEntryEnabled}
          onCheckedChange={onManualEntryChange}
        />
      </div>

      <div className="flex items-center justify-between p-3 border rounded-lg">
        <div>
          <Label htmlFor="bulk-import" className="text-sm">
            Importação em Massa
          </Label>
          <p className="text-xs text-muted-foreground">
            Permitir importar planilhas (CSV/Excel)
          </p>
        </div>
        <Switch
          id="bulk-import"
          checked={bulkImportEnabled}
          onCheckedChange={onBulkImportChange}
        />
      </div>
    </div>
  );
}
